import React, { useEffect } from "react";
import {
    Button,
    Input,
    Form,
    message,
} from "antd";
import { useHistory } from 'react-router-dom';

import { cookie } from "./approach/base";

function FormMoudle() {

    const [forms] = Form.useForm();
    const history = useHistory();

    const { postLogin } = window.$axios.request;

    useEffect(() => {
        
    }, [])

    const onFinish = (values) => {
        // console.log(values)
        // postLogin({},{...values}).then(res => {
        //     // console.log(res)
        //     cookie.set("userInfo",JSON.stringify(res.result),1);
        //     message.success("登录成功！");
        //     history.push("/administrator");
        // }).catch(err => {
        //     message.error(err.message);
        // })
        cookie.set("userInfo",JSON.stringify(values),1);
        history.push("/manage/bidding");
    };

    const renderForm = () => {
        return (
            <Form layout="horizontal"
            style={{ border: '1px solid #ddd', width: 400, height: 250, padding: 30, borderRadius: 10, boxShadow: '0 0 10px #ddd', position: 'absolute', top: "50%", left: "50%",transform: "translate(-50%, -50%)" }}
            form={forms}
            onFinish={onFinish}
            initialValues={{ username: "", password: "" }}
            >
                <Form.Item>
                <p style={{textAlign:"center",fontWeight:"bold",marginBottom: 0}}>管理后台</p>
                </Form.Item>
                <Form.Item
                    label=""
                    name="username"
                    rules={[
                        {required:true,message:"请输入账号"},
                    ]}
                >
                    <Input
                        placeholder="请输入账号"
                        maxLength={200}
                    />
                </Form.Item>

                <Form.Item
                    label=""
                    name="password"
                    rules={[
                        {required:true,message:"请输入密码"},
                    ]}
                >
                    <Input.Password
                        visibilityToggle={false}
                        placeholder="请输入密码"
                        maxLength={200}
                    />
                </Form.Item>

                <Form.Item
                    className="formItem"
                    style={{ textAlign: "center" }}
                >   
                    <Button style={{ marginLeft: 10 }} type="primary" htmlType="submit">登录</Button>
                </Form.Item>
            </Form>
        )
    }

    return (
        <React.Fragment>
            {renderForm()}
        </React.Fragment>
    )
}

export default FormMoudle;
